// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NkkCl","active":"styles_active__Zvmda"};